module.exports = __webpack_public_path__ + "f60c5595ecda08ccc63232cc2ae58f4e.pdf";